'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
exports.isString = isString;
exports.isBoolean = isBoolean;
exports.isNumber = isNumber;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isNonEmptyOrBlankString = isNonEmptyOrBlankString;
exports.isGuid = isGuid;
exports.isTag = isTag;
exports.isProperLengthString = isProperLengthString;
exports.isArrayOf = isArrayOf;
exports.isUndefinedOr = isUndefinedOr;
exports.isHttpErrorCode = isHttpErrorCode;
exports.or = or;
exports.and = and;
function isString(value) {
  return typeof value === 'string';
}
function isBoolean(value) {
  return typeof value === 'boolean';
}
function isNumber(value) {
  return typeof value === 'number';
}
function isFunction(value) {
  return typeof value === 'function';
}
function isObject(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}
function isNonEmptyOrBlankString(value) {
  return this.isString(value) && value.trim().length > 0;
}
function isGuid(value) {
  return this.isString(value) && /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/.test(value);
}
function isTag(value) {
  return this.isString(value) && /^[a-z0-9_\.-]{2,30}$/.test(value);
}
function isProperLengthString(value, maxInclusiveLength) {
  return this.isString(value) && value.length <= maxInclusiveLength;
}
function isArrayOf(f, value) {
  var _this = this;
  return Array.isArray(value) && value.every(function (elem) {
    return f.call(_this, elem);
  });
}
function isUndefinedOr(f) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return params[0] === undefined || f.call.apply(f, [this].concat(params));
}
function isHttpErrorCode(value) {
  return this.isNumber(value) && /^[45][0-9]{2}$/.test(value);
}
function or(value) {
  var _this2 = this;
  for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    functions[_key2 - 1] = arguments[_key2];
  }
  return functions.some(function (f) {
    return f.call(_this2, value);
  });
}
function and(value) {
  var _this3 = this;
  for (var _len3 = arguments.length, functions = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    functions[_key3 - 1] = arguments[_key3];
  }
  return functions.every(function (f) {
    return f.call(_this3, value);
  });
}